import { html } from 'lit';
import { customElement } from 'lit/decorators.js';

import { TefComsBaseSelect } from './TefComsBaseSelect';

//
// renders a simple <select> with all available channels fetched from the core API
//
@customElement('tef-coms-channel-select')
export class TefComsChannelSelect extends TefComsBaseSelect {
  data: string[];

  async connectedCallback() {
    this.data = await this.api<string[]>('service/metachannels');
    super.connectedCallback();
  }

  render() {
    const options = this.data.map((entry) => html`
      <option value="${entry}" ?selected=${this.selected === entry}>${entry}</option>
    `);

    return html`
      <select name="channel" id="channel-select" class="form-select">
        <option value="">Select a Channel</option>
        ${options}
      </select>
    `;
  }
}
